import type { FC } from 'react';
import { Container } from '@/DesignSystem/Component';
const TeacherListHeader: FC = () => {
  return <div data-sentry-component="TeacherListHeader" data-sentry-source-file="TeacherListHeader.tsx">
      <Container data-sentry-element="Container" data-sentry-source-file="TeacherListHeader.tsx">
        <div className="py-8 sm:px-16">
          <span className="mb-3 text-base font-bold text-blueFive sm:text-2xl">سخت نگیر؛ یاد بگیر:</span>
          <h1 className="mb-4 text-2xl font-bold text-blueFive sm:text-4xl"> معلم های آی‌نو</h1>
          <p className="text-xl">
            اگر میخواین با معلم های آی‌نو بیشتر آشنا بشین و بدونید کجا ها درس میدن ، تحصیلاتشون چیه و چه رزومه ای دارن
            میتونین روی عکس هر دبیری که میخوایین کلیک کنین و ببینین.
          </p>
        </div>
      </Container>
    </div>;
};
export default TeacherListHeader;